import type { CSSProperties, FC } from 'react';
import { Progress } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

export interface PlatformProgressBarProps {
    ariaLabel?: string;
    percent: number;
    style?: CSSProperties;
}

/** Tokenized linear progress shared by billing and dense resource previews. */
const PlatformProgressBar: FC<PlatformProgressBarProps> = ({ ariaLabel, percent, style }) => {
    const { token } = useAntDesignTheme();

    return (
        <Progress
            aria-label={ariaLabel}
            percent={Math.min(100, Math.max(0, percent))}
            showInfo={false}
            strokeColor={token.blue6}
            success={{ strokeColor: token.blue6 }}
            style={style}
        />
    );
};

export default PlatformProgressBar;
